import faker from 'faker'

/**
 * @param _
 * @param idx
 */
function genItem (_, idx) {
  return {
    assessNO: idx,
    assessTime: Date.now(),
    result: '过敏 #' + idx,
    propose: faker.lorem.sentence()
  }
}

const answerLists = Array.from(Array(8)).map(genItem)

export default {
  data: {
    answerLists
  }
}
